import createOrmSelector from 'redux/utils/createOrmSelector';

export default createOrmSelector(
  (session) => {
    const { ChemicalElement } = session;

    return ChemicalElement.all().toRefArray();
  },
);
